import type { MessengerFeatureConfig } from './type';

export const messenger: MessengerFeatureConfig = {
    // when 0, polling is turned off
    threadPollingInterval: 30000,
    threads: {
        allowedExternalImgUrls: [],
    },
    maximumAttachmentsLimit: 10,
    maximumAttachmentSizeLimitInMBs: 10,
    totalAttachmentsSizeLimitInMBs: 100,
    includeUserNameInMessageBody: false,
    apiSupportsTypeFlag: false,
    defaultAllowedAttachmentExtensions: [
        'pdf',
        'txt',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'jpeg',
        'jpg',
        'gif',
        'png',
        'tif',
        'tiff',
    ],
    extendedAllowedAttachmentExtensions: [],
    attachmentNameEncoded: false,
};
